module.exports = __webpack_public_path__ + "media/images/lb/519-59a1b4a33dfa1e6195f755e549836828.svg";